import { RootState } from '@/app/model/store';

import { organizationStaffAdapter } from './organizationStaffSlice';

export const organizationStaffSelectors = organizationStaffAdapter.getSelectors(
  (state: RootState) => state.organizationStaff,
);

export const selectLoading = (state: RootState) =>
  state.organizationStaff.loading;
